/**
 * Level 6: Space
 * 
 * Low gravity environment with unique challenges:
 * - Reduced gravity (0.4)
 * - Asteroid hazards (moving)
 * - Portal shortcuts
 * - Magnetic boxes in zero-G
 * 
 * @module configs/levels/Level06_Space
 */

/** @type {import('../LevelTypes').LevelConfig} */
const Level06_Space = {
    id: 6,
    name: 'Space',
    subtitle: 'Zero Gravity',
    description: 'Low gravity environment with asteroid hazards.',
    
    worldWidth: 4000,
    worldHeight: 2000,
    playerStart: { x: 100, y: 1700 }, // Spawns on ground platform
    gravity: 0.4, // Low gravity for space feel
    
    theme: {
        bgGradient: ['#000000', '#0b3d91'],
        platformColor: 0xcccccc,
        accentColor: 0x00ffff,
        particleColor: 0x00ffff
    },
    
    platforms: [
        { x: 0, y: 1800, w: 400, h: 50 },
        { x: 500, y: 1500, w: 150, h: 20 },
        { x: 900, y: 1200, w: 150, h: 20 },
        { x: 1300, y: 900, w: 200, h: 20 },
        { x: 1700, y: 1400, w: 200, h: 20 },
        { x: 2100, y: 1100, w: 150, h: 20 },
        { x: 2500, y: 1600, w: 300, h: 50 },
        { x: 3000, y: 1200, w: 200, h: 20 },
        { x: 3500, y: 800, w: 500, h: 50 }
    ],
    
    movingPlatforms: [
        { x: 250, y: 1650, w: 120, h: 20, moveY: 250, speed: 0.002 },
        { x: 1100, y: 1050, w: 120, h: 20, moveX: 150, speed: 0.003 },
        { x: 2300, y: 1350, w: 100, h: 20, moveY: 200, speed: 0.0025 }
    ],
    
    spikes: [
        { x: 2600, y: 1600 },
        { x: 2650, y: 1600 },
        { x: 2700, y: 1600 }
    ],
    
    stars: [
        { x: 500, y: 1400 },
        { x: 1300, y: 800 },
        { x: 2100, y: 1000 },
        { x: 3000, y: 1100 },
        { x: 3700, y: 700 }
    ],
    
    enemies: [
        { x: 2550, y: 1550 },
        { x: 3600, y: 750 }
    ],
    
    door: { x: 3900, y: 650, w: 50, h: 300 },
    button: { x: 3600, y: 795 },
    box: { x: 1775, y: 1350, floating: true }, // MAGNETIC BOX
    goal: { x: 3950, y: 700 },
    
    portals: [
        { x1: 700, y1: 1750, x2: 2800, y2: 1550, color: 0x00ffff }
    ],
    
    asteroids: [
        { x: 1500, y: 1100, radius: 40, speed: 0.001 },
        { x: 2200, y: 900, radius: 30, speed: 0.0015 },
        { x: 3200, y: 1000, radius: 35, speed: 0.001 }
    ],
    
    speedrunTargets: { gold: 55, silver: 75, bronze: 100 }
};

export default Level06_Space;
